export const modulationUserContractsCachekeys = {
  all: (membership_id: number) => ['modulation_user_contracts', membership_id],
  createOne: () => ['create_modulation_contract'] as const
}
